import { createAsyncAction, createAction } from 'typesafe-actions';
import { AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { webApiGet } from '../../api/client'
import SearchResult from '../../api/models/SearchResult';
import { SearchFilter, CategoryFilter, PropertyFilter } from '../../models/SearchFilter';
import { TaxonomyElement } from '../../api/models/TaxonomyElement';
import { OrderSheetItemData } from '../../api/models/OrderSheetData';


export const loadTaxonomyAsync = createAsyncAction(
    "LOAD_TAXONOMY_REQUEST",
    "LOAD_TAXONOMY_SUCCESS",
    "LOAD_TAXONOMY_ERROR")<undefined, TaxonomyElement, Error>()


export const loadTaxonomyAsyncThunk = (): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        return new Promise<void>((resolve) => {
            dispatch(loadTaxonomyAsync.request())
            webApiGet('/offer/category',
                (data: TaxonomyElement) => { dispatch(loadTaxonomyAsync.success(data)); resolve() },
                (err: Error) => { dispatch(loadTaxonomyAsync.failure(err)); resolve() },
                null,
                3
            )
        })
    }
}

export const searchTaxonomyAsync = createAsyncAction(
    "SEARCH_TAXONOMY_REQUEST",
    "SEARCH_TAXONOMY_SUCCESS",
    "SEARCH_TAXONOMY_ERROR")<undefined, SearchResult, Error>()


export const searchTaxonomyAsyncThunk = (query: string, startFrom: number, limit: number, filters: { [name: string]: string[] }, strict : boolean): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        return new Promise<void>((resolve) => {
            dispatch(searchTaxonomyAsync.request())
            webApiGet('/offer/product/search',
                (data: SearchResult) => {
                    if (startFrom > 0)
                        data.nextPage = true
                    dispatch(searchTaxonomyAsync.success(data))
                    resolve()
                },
                (err: Error) => { dispatch(searchTaxonomyAsync.failure(err)); resolve() },
                { query: query || '*', startFrom, limit, filters: (Object.keys(filters).length === 0 ? { 'category': 'https://qmo.com/Food' } : filters), strict },
                3
            )
        })
    }
}

export const applyFilter = createAction("APPLY_FILTER")<SearchFilter>()
export const removeFilter = createAction("REMOVE_FILTER")<SearchFilter>()
export const setProductProperty = createAction("SET_PRODUCT_PROPERTY")<OrderSheetItemData>()
export const resetAndReplaceFilter = createAction("RESET_AND_REPLACE_FILTER")<{categoryFilter?:CategoryFilter | null, propertyFilter?:PropertyFilter | null}>()